import React,{Suspense} from 'react';
import { Routes, Route,useLocation    } from 'react-router-dom';
import routes from '../routes';
import Page404 from '../pages/page404/page404';
import Dashboard from '../pages/Dashboard'

const loading = (
  <div className="col-xs-12 text-center">
    <div className="spinner-border text-primary"></div>
  </div>
);
const Content = () =>{
  
  const location = useLocation();
  const currentUrl = location.pathname;
  const urlSegments = currentUrl.split('/');
const lastName = urlSegments[urlSegments.length - 1];

// console.log('Content component - Current URL:', currentUrl);
// console.log('Content component - URL segments:', urlSegments);
// console.log('Content component - Last segment:', lastName);

//console.log(lastName); // Output: "list"
return(
    <div className={`col-sm-12 col-md-9 col-lg-10 ${lastName === 'list' ? 'table-width-full' : 'full-width'}`}>
              <div>
              {/* <h1 className="fs-4 font-weight-600">Add Passenger</h1> */}
                <div className="tab-content">
                <Suspense fallback={loading}>
                <Routes>
            {/* Default route for /home */}
            <Route path="" element={<Dashboard />} />
            {/* Render all routes */}
            {routes.map((route, idx) => {
              //console.log('Rendering route:', route.path, 'with component:', route.component);
              return route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  element={<route.component />} />
              )
            })}
            <Route path="*" element={<Page404 />} />
          </Routes>
                </Suspense>
                </div>
              </div>
          </div>
);
}
export default Content;